var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagBolivia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15040)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16.0009C32 14.0437 31.648 12.1689 31.0048 10.4357L16 9.73999L0.995188 10.4356C0.352 12.1689 0 14.0437 0 16.0009C0 17.958 0.352 19.8328 0.995188 21.5661L16 22.2617L31.0048 21.5661C31.648 19.8328 32 17.958 32 16.0009Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32.001C22.8794 32.001 28.7441 27.659 31.0048 21.5662H0.995193C3.25588 27.659 9.12057 32.001 16 32.001Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.995193 10.4358H31.0049C28.7441 4.34298 22.8794 0.000976562 16 0.000976562C9.12057 0.000976562 3.25588 4.34298 0.995193 10.4358Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15040"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagBolivia);
export default __webpack_public_path__ + "static/media/flag_bolivia.033da1d5a0b373360dccea75fe52f7a4.svg";
export { ForwardRef as ReactComponent };